var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.3 14L77 17.6L80.9 18.2L78.1 20.9L78.8 24.8L75.3 23L71.8 24.8L72.4 20.9L69.6 18.2L73.5 17.6L75.3 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6 78.7L48.4 82.2L52.3 82.7999L49.5 85.6L50.1 89.4999L46.6 87.6L43.1 89.4999L43.8 85.6L41 82.7999L44.9 82.2L46.6 78.7Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.7001C17.7 27.5001 23.1 28.7 29.7 27.3C37.9 25.6 43.1 20.8 45 18.8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 26.5L21.9 39.9L26.9 27.8L17.3 26.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 27.9001L33.6 39.4001L35.2 25.7001L25.8 27.9001Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7 26L45.7 33.7L41.9 21L33.7 26Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8 71.1001C71.2 72.7001 74.1 75.7001 78.7 77.2001C84.4 79.1001 87 78.4 89.8 77.8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72.1001L69.5 86.1001L79.8 77.8L72 72.1001Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 77.2001L80.7 89.0001L87.1 78.4001L77.5 77.2001Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3 67.1C86.1225 67.1 87.6 65.6225 87.6 63.8C87.6 61.9774 86.1225 60.5 84.3 60.5C82.4775 60.5 81 61.9774 81 63.8C81 65.6225 82.4775 67.1 84.3 67.1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 48.8C23.8 49.8 24.2 51.8001 23.3 53.4001C22.3 55.0001 20.3 55.4001 18.7 54.5001",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8 37.2002L76.7 34.5001C77.8 33.8001 79.3 34.1002 80 35.1002C80.7 36.2002 80.4 37.7002 79.4 38.4002L75.5 41.1002",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 41.8L78.4 39.1C79.5 38.4 81 38.7 81.7 39.7C82.4 40.8 82.1 42.3 81.1 43L77.2 45.7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4 46.9001L79.3 44.2001C80.4 43.5001 81.9 43.8001 82.6 44.8001C83.3 45.9001 83 47.4001 82 48.1001L72.9 54.2001C72.1 54.7001 71.3 55.2001 70.5 55.6001L63.3 59.3001",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3 47.5001L58.5 41.4001C59.5 39.5001 59.6 37.4001 58.9 35.4001L56.5 29.0001C56.1 27.9001 56.8 26.6001 57.9 26.4001H58.1C60.1 26.0001 62.1 27.1001 62.9 29.0001L65.8 36.2001L74.9 30.1001C76 29.4001 77.5 29.7001 78.2 30.7001C78.6 31.2001 78.7 31.9001 78.6 32.5001C78.5 33.1001 78.1 33.7001 77.6 34.0001L73.7 36.7001",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0329 44.1495L41.5125 51.9265L53.5977 69.8286L65.1181 62.0515L53.0329 44.1495Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 86.8L52.3 67.8L43 54.1001L15.9 70.7001L26.8 86.8Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6 62.6002H55.1C54.5 62.6002 54 62.1001 54 61.5001V60.0001C54 59.4001 54.5 58.9001 55.1 58.9001H56.6C57.2 58.9001 57.7 59.4001 57.7 60.0001V61.5001C57.7 62.1001 57.2 62.6002 56.6 62.6002Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.d69d01063dea86de632c19758480bb91.svg";
export { ForwardRef as ReactComponent };